import React, { useState } from "react";
import api from "../axiosConfig";

const ExportarExcel = ({ refrescarDatos }) => {
  const [fecha, setFecha] = useState("");
  const [filtro, setFiltro] = useState("dia");
  const [filtroNombreCita, setFiltroNombreCita] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [mensaje, setMensaje] = useState("");

  const ejecutarRefresco = () => {
    if (typeof refrescarDatos === "function") refrescarDatos();
  };

  const descargarArchivo = (response, nombreArchivo) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.setAttribute("download", nombreArchivo);
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
    window.URL.revokeObjectURL(url);
  };

  const exportarCitas = async () => {
    if (!fecha || !filtro) return setMensaje("Selecciona filtro y fecha.");
    try {
      const res = await api.get("/exportar/citas", { params: { filtro, fecha }, responseType: "blob" });
      descargarArchivo(res, `citas_${filtro}_${fecha}.xlsx`);
      setMensaje("Exportación de citas completada.");
      setFecha("");
    } catch { setMensaje("Error al exportar citas."); }
  };

  const exportarCitasPorCliente = async () => {
    if (!filtroNombreCita.trim()) return setMensaje("Escribe nombre del cliente.");
    try {
      const res = await api.get("/exportar/citas", { params: { nombre_cliente: filtroNombreCita }, responseType: "blob" });
      descargarArchivo(res, `citas_${filtroNombreCita}.xlsx`);
      setMensaje("Exportación de citas por cliente completada.");
      setFiltroNombreCita("");
    } catch { setMensaje("Error al exportar citas por cliente."); }
  };

  const exportarClientes = async () => {
    try {
      const res = await api.get("/clientes_excel/", { params: filtroCliente ? { nombre: filtroCliente } : {}, responseType: "blob" });
      descargarArchivo(res, `clientes_${filtroCliente}.xlsx`);
      setMensaje("Exportación de clientes filtrados completada.");
      setFiltroCliente("");
    } catch { setMensaje("Error al exportar clientes."); }
  };

  const exportarTodosClientes = async () => {
    try {
      const res = await api.get("/clientes_excel/", { responseType: "blob" });
      descargarArchivo(res, `todos_los_clientes.xlsx`);
      setMensaje("Exportación de todos los clientes completada.");
      ejecutarRefresco();
    } catch { setMensaje("Error al exportar todos los clientes."); }
  };

  const btnGradiente = {
    background: "linear-gradient(90deg, #4e73df, #1cc88a)",
    color: "white",
    border: "none",
    fontSize: "0.8rem",
    padding: "0.35rem 0.6rem"
  };

  return (
   <div 
  className="card p-3 mb-3" 
  style={{ 
    borderRadius: "0.75rem", 
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "inline-block",       // hace que solo ocupe lo necesario
    width: "auto",                 // ancho automático según contenido
    minWidth: "300px"              // opcional, evita que se vea muy pequeño
  }}
>
      <h6 className="mb-2 text-dark text center">Exportar Datos</h6>

      {/* Citas por Fecha */}
      <div className="d-flex flex-wrap align-items-end gap-2 mb-2">
        <select className="form-select form-select-sm" style={{ maxWidth: "100px" }} value={filtro} onChange={(e) => setFiltro(e.target.value)}>
          <option value="dia">Día</option>
          <option value="semana">Semana</option>
          <option value="mes">Mes</option>
        </select>
        <input type="date" className="form-control form-control-sm" style={{ maxWidth: "160px" }} value={fecha} onChange={(e) => setFecha(e.target.value)} />
        <button className="btn" style={btnGradiente} onClick={exportarCitas}>Citas Fecha</button>
      </div>

      {/* Citas por Cliente }
      <div className="d-flex flex-wrap align-items-end gap-2 mb-2">
        <input type="text" className="form-control form-control-sm" style={{ maxWidth: "200px" }} placeholder="Nombre cliente" value={filtroNombreCita} onChange={(e) => setFiltroNombreCita(e.target.value)} />
        <button className="btn" style={btnGradiente} onClick={exportarCitasPorCliente}>Citas Cliente</button>
      </div>

      {/* Clientes 
      <div className="d-flex flex-wrap align-items-end gap-2 mb-2">
        <input type="text" className="form-control form-control-sm" style={{ maxWidth: "200px" }} placeholder="Filtrar nombre" value={filtroCliente} onChange={(e) => setFiltroCliente(e.target.value)} />
        <button className="btn" style={btnGradiente} onClick={exportarClientes}>Filtrados</button>
        <button className="btn btn-secondary btn-sm" onClick={exportarTodosClientes}>Todos</button>
      </div>

      {mensaje && <div className="alert alert-light mt-1 py-1">{mensaje}</div>}*/}
    </div>
  );
};

export default ExportarExcel;
